module.exports = __webpack_public_path__ + "static/media/Foreground.4962f6e5.png";